<template>
    <div class="row ml-0 col-lg-12">
        <div class="ml-0 col-lg-6">
            <div>
                <chartPatrimonies @shareRadius="shareRadius" :data="this.data" type='LCOE_POWER' :pointData="this.pointData" :share="this.share"></chartPatrimonies>
            </div>
        </div>
        <div class="ml-0 col-lg-6">
            <div>
                <chartPatrimonies @shareRadius="shareRadius" :data="this.data" type='PVREADY_POWER' :pointData="this.pointData" :share="this.share"></chartPatrimonies>
            </div>
        </div>
        <div class="ml-0 col-lg-3"></div>
        <div class="ml-0 col-lg-6">
            <div>
                <chartPatrimonies @shareRadius="shareRadius" :data="this.data" type='LCOE_PVREADY' :pointData="this.pointData" :share="this.share"></chartPatrimonies>
            </div>
        </div>
    </div>
</template>

<script>
    import chartPatrimonies from './chartPatrimonies.vue'

    export default {
        name: 'charts-patrimonie-setup',
        props:['data'],
        components: {
            chartPatrimonies
        },
        data:function(){
            return { 
                share:false,//props utilisé comme un flag, le changement de valeur est obesrvé dans la vue enfant
                pointData:[],
            };
        },
        methods:{
            shareRadius(datasetIndex,pointIndex){
                this.pointData['datasetIndex'] = datasetIndex;
                this.pointData['pointIndex'] = pointIndex;
                this.share = (!this.share);
            },
        }
    }
</script>